import { FC, useState } from 'react';
import { TruncateText } from 'src/components/TruncateText';
import { Link } from 'react-router-dom';
import {
  defaultNotification,
  ToastNotification,
} from 'src/components/ToastNotification/Notification';
import './styles.scss';

interface ObjectIdentifierProps {
  id: string;
  to?: string;
  title?: string;
}
export const ObjectIdentifier: FC<ObjectIdentifierProps> = ({ id, to, title }) => {
  const DISPLAY_NOTIFICATION_TIMEOUT = 5000000;

  let formattedId = id.replace(/[{}]/g, '').toLowerCase();
  const [notification, setNotification] = useState(defaultNotification);

  const toggleNotification = () => {
    setNotification({
      isOpen: true,
      type: 'success',
      text: 'Copied to clipboard',
    });

    setTimeout(() => {
      setNotification(defaultNotification);
    }, DISPLAY_NOTIFICATION_TIMEOUT);
  };

  const onCopy = async () => {
    await navigator.clipboard.writeText(formattedId);
    toggleNotification();
  };

  return (
    <div className="objectIdentifier">
      <div className="objectIdentifier__wrapper">
        {to ? (
          <Link
            to={to}
            title={title}
            data-testid="object-identifier-link"
          >
            <TruncateText text={formattedId} toTruncateTextAlways={true} />
          </Link>
        ) : (
          <TruncateText text={formattedId} toTruncateTextAlways={true}/>
        )}
        <i
          className="icon-ui-general-copy objectIdentifier__copyIcon"
          role="button"
          aria-label="Copy"
          tabIndex={0}
          onClick={onCopy}
          onKeyDown={event => {
            if (event.key === 'Enter' || event.key === ' ') {
              onCopy();
            }
          }}
          data-testid="object-identifier-copy"
        />
      </div>
      <ToastNotification notification={notification} setNotification={setNotification} />
    </div>
  );
};
